/**
* Version 0.100
* 
* Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
* Copyright 2016 - 2025.
* 
* !Changelog

* 	17-10-2018
* 	- [BORN] This class is born. Hooray!
* 
* !Usage
* 
*   - 
* 	
* !Wishlist
* 
* 	// none
* 	
*/

var specific_ufo = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	var ufo = null;
	var planets = [];
	var overplanet = false;
	var ufoRotation = 0;

	this.onready = function () {

		var isAgent = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(navigator.userAgent);
		var isWindowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		
		var isMobile = false;
		if (
			isAgent === true ||
			isWindowWidth < 768
		) {
			isMobile = true;
		}

		/**
		 * Set universe background with stars
		 */
		var universe = document.querySelector('.universe');
		if (universe) {

			var starsCount = 200; // Number of stars

			if (
				isMobile
			) {
				starsCount = 50;
			}

			for (var i = 0; i < starsCount; i++) {
				
				/**
				 * Make star
				 */
				var star = document.createElement('div');
				star.classList.add('star');
				star.style.top = Math.random() * 100 + '%';
				star.style.left = Math.random() * 100 + '%';

				/**
				 * Add star to body
				 */
				universe.appendChild(star);
				
			}
		}

		/**
		 * Twinkle some of the stars
		 */
		var stars = document.querySelectorAll('.star');
		stars.forEach(function (star) {
			if (Math.random() < 0.3) {		
				
				/**
				 * Twinkle version 1, 2 or 3 
				 */
				var twinkleVersion = Math.floor(Math.random() * 3) + 1;
				star.classList.add('twinkle-' + twinkleVersion);

			}
		});

		// /**
		//  * Cache planets once (center + influence radius)
		//  */
		// planets = Array.prototype.slice.call(
		// 	document.querySelectorAll('.planet')
		// ).map(function (planet) {

		// 	var rect = planet.getBoundingClientRect();

		// 	return {
		// 		el: planet,
		// 		x: rect.left + rect.width / 2,
		// 		y: rect.top + rect.height / 2,
		// 		radius: Math.max(rect.width, rect.height) * 0.8
		// 	};
		// });

		/**
		 * Detect when mouse is over planet
		 */
		var planetElements = document.querySelectorAll('.planet');
		planetElements.forEach(function (planet) {

			planet.addEventListener('mouseenter', function () {
				overplanet = true;
			});

			planet.addEventListener('mouseleave', function () {
				overplanet = false;
			});

		});
		
		/**
		 * Define UFO
		 */
		ufo = document.querySelector('.js-ufo');
		
		if (!ufo) {
			return;
		}

		/**
		 * Get UFO dimensions width and height of div
		 */
		var _ufo_width = ufo.offsetWidth / 2;
		var _ufo_height = ufo.offsetHeight / 2;

		var lastSafeX = window.innerWidth / 2 - _ufo_width;
		var lastSafeY = window.innerHeight / 2 - _ufo_height;
		
		/**
		 * Fly to the center first with animation
		 */
		ufo.style.transition = 'transform 1s ease-in-out';
		specific_ufo.renderUfo(lastSafeX, lastSafeY, ufoRotation);
		
		/**
		 * Is the device mobile?
		 */
		if (
			isMobile
		) {

			/**
			 * Automatic floating UFO on mobile over the screen
			 */
			var floatX = 0;
			var floatY = 0;

			setInterval(function () {
				
				// Get random position but stay within window bounds
				floatX = Math.random() * (window.innerWidth - _ufo_width);
				floatY = Math.random() * (window.innerHeight - _ufo_height);
				
				// Set last safe positions
				lastSafeX = floatX;
				lastSafeY = floatY;

				specific_ufo.renderUfo(lastSafeX, lastSafeY, ufoRotation);
			}, 2000);
				
		} else {

			/**
			 * Device is desktop
			 */
			document.addEventListener('mousemove', function (e) {
				
				setTimeout(function () {

					var mouseX = e.clientX;
					var mouseY = e.clientY;

					// If overplanet then make UFO next to planet
					if (overplanet === true) {
						lastSafeX = mouseX - _ufo_width - 150;
						lastSafeY = mouseY - _ufo_height - 150;
					} else {

						var result = specific_ufo.isMouseOverPlanet(mouseX, mouseY);

						var speed = 1 - result.influence;
						var duration = 0.3 + (1.5 * speed);

						mouseX = Math.min(window.innerWidth - _ufo_width, mouseX);
						mouseY = Math.min(window.innerHeight - _ufo_height, mouseY);

						// Calculate last safe positions
						lastSafeX = mouseX - _ufo_width;
						lastSafeY = mouseY - _ufo_height;

						ufo.style.transition = 'transform ' + duration + 's ease-out';
						specific_ufo.renderUfo(lastSafeX, lastSafeY, ufoRotation);
						
					}

				}, 500);

			});
			
		}
			
		/**
		 * Every 1 second rotate UFO a bit randomly
		 */
		setInterval(function () {

			/**
			 * Rotate randomly between -10 and +10 degrees
			 */
			var ufoRotation = Math.floor(Math.random() * 20) - 10;

			specific_ufo.renderUfo(lastSafeX, lastSafeY, ufoRotation);
		}, 1000);

		/**
		 * .ufo-blasting randomly timing
		 */
		setInterval(function () {
		
			var blastingElements = document.querySelectorAll('.body-blasting');
			blastingElements.forEach(function(element) {
				element.style.opacity = '1';

				var _randomDuration = 300 + Math.random() * 700; // Random duration between 300ms and 1000ms

				setTimeout(function() {
					element.style.opacity = '';
				}, _randomDuration);
			});
			
		}, 2000 + Math.random() * 4500); // Random interval between 2 and 4.5 seconds

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	this.renderUfo = function(x, y, rotation) {
		ufo.style.transform = 'translate(' + x + 'px, ' + y + 'px) rotate(' + rotation + 'deg)';
	};
	

	this.isMouseOverPlanet = function (
		mouseX,
		mouseY,
		overplanet
	) {
		
		var maxInfluence = 0;

		for (var i = 0; i < planets.length; i++) {
			var p = planets[i];

			var dx = mouseX - p.x;
			var dy = mouseY - p.y;
			var distance = Math.sqrt(dx * dx + dy * dy);

			if (distance < p.radius) {
				var influence = 1 - (distance / p.radius);
				maxInfluence = Math.max(maxInfluence, influence);
			}
		}

		return {
			overplanet: overplanet,
			influence: maxInfluence
		};

	};

}).apply(specific_ufo);